import React from "react";
import { superviseEmpty } from "@/assets/img";
import { changeEgovUrl } from "@/utils/tools";

export default function Empty({
  src,
  text,
  noImage = false
}: {
  src?: string;
  text?: string;
  noImage?: boolean;
}) {
  return (
    <div
      style={{
        textAlign: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "#62656D"
      }}
    >
      {!noImage ? (
        <img
          style={{
            width: 150,
            height: 150
          }}
          src={changeEgovUrl(src || superviseEmpty)}
        />
      ) : null}
      <p>{text}</p>
    </div>
  );
}
